import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

@connect(
)
export class ReduxRouteChanged extends React.Component {

  constructor(props) {
    super(props);
    this.state = {isResolved: false};
  }

  componentDidMount() {
    this.handleRouteChanged(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const {params: nextParams, location: {query: nextQuery}} = nextProps;
    const {params, location: {query}} = this.props;

    if ((JSON.stringify(params) !== JSON.stringify(nextParams)) || (JSON.stringify(query) !== JSON.stringify(nextQuery))) {
      this.handleRouteChanged(nextProps);
    }
  }

  handleRouteChanged(props) {
    const {dispatch, params, location: {query}} = props;
    this.setState({isResolved: false});

    const routeChanged = props.routeChanged || Function();

    //http://stackoverflow.com/questions/27746304/how-do-i-tell-if-an-object-is-a-promise/38339199
    let routeChangedPromise = Promise.resolve(routeChanged(dispatch, params, query));

    routeChangedPromise.then(
      () => this.setState({isResolved: true})
    );
  }

  render() {
    const {component} = this.props;
    return this.state.isResolved ? React.createElement(component) : null;
  }
}

ReduxRouteChanged.propTypes = {
  location: PropTypes.object,
  params: PropTypes.object,
  routeChanged: PropTypes.func,
  component: PropTypes.func
};

const reduxRouteChanged = (routeChanged, component) => {
  return (props) => <ReduxRouteChanged {...props} routeChanged={routeChanged} component={component} />; // eslint-disable-line react/display-name, react/no-multi-comp
};

export default reduxRouteChanged;



// WEBPACK FOOTER //
// ./src/services/reduxRouteChanged.js